<template>
  <v-dialog v-model="isOpen" :fullscreen="fullscreen" :max-width="max_width" :persistent="persistent">
    <v-card v-if="!content_filled">
      <v-toolbar color="toolbar" dark>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <component :is="component" v-model:model2="model2.value" v-bind="props" @close="close"/>
      </v-card-text>
    </v-card>
    <component :is="component" v-if="content_filled" v-model:model2="model2.value" v-bind="props" @close="close"/>
  </v-dialog>
</template>

<script lang="ts" setup>
import {ref} from 'vue';

/**
 * Standardwerte eines Dialogs. Bei jedem open() wird auf diese zurückgesetzt,
 * damit nicht gesetzte Optionen NICHT die Werte des vorherigen Dialogs erben
 * (sonst bleibt z.B. fullscreen aus einem früheren Aufruf hängen).
 */
const DEFAULTS = {
  dialogTitle: 'Dialog',
  maxWidth: undefined as number | undefined,
  contentFilled: false,
  fullscreen: false,
  persistent: false,
  model2: 0 as any,
};

interface PopupOptions {
  contentFilled?: boolean,
  dialogTitle?: string,
  maxWidth?: number,
  fullscreen?: boolean,
  persistent?: boolean,
  model2?: any,
}

const isOpen = ref(false);
const component = ref<any>(null);
const props = ref<any>({});
const title = ref<string>(DEFAULTS.dialogTitle);
const max_width = ref<number | undefined>(DEFAULTS.maxWidth);
const content_filled = ref<boolean>(DEFAULTS.contentFilled);
const fullscreen = ref<boolean>(DEFAULTS.fullscreen);
const persistent = ref<boolean>(DEFAULTS.persistent);
const model2 = ref<any>(DEFAULTS.model2);

function open(comp: any, compProps = {}, options: PopupOptions = {}) {
  component.value = comp;
  props.value = compProps;
  title.value = options.dialogTitle ?? DEFAULTS.dialogTitle;
  max_width.value = options.maxWidth ?? DEFAULTS.maxWidth;
  content_filled.value = options.contentFilled ?? DEFAULTS.contentFilled;
  fullscreen.value = options.fullscreen ?? DEFAULTS.fullscreen;
  persistent.value = options.persistent ?? DEFAULTS.persistent;
  model2.value = options.model2 ?? DEFAULTS.model2;
  isOpen.value = true;
}

function close() {
  isOpen.value = false;
}

defineExpose({open, close});
</script>
